import { IconLibrary, IconSearchOff, IconTrashOff, type Icon } from "@tabler/icons-react";

type EmptyStateVariant = "search" | "empty" | "deleted";

const VARIANTS: Record<EmptyStateVariant, { icon: Icon; title: string; subtitle: string }> = {
  search: {
    icon: IconSearchOff,
    title: "No results found",
    subtitle: "Try a different keyword or check the spelling.",
  },
  empty: {
    icon: IconLibrary,
    title: "No slides yet",
    subtitle: "Add your first slide to start building faster",
  },
  deleted: {
    icon: IconTrashOff,
    title: "Nothing here yet",
    subtitle: "Slides you delete will appear here before they're permanently removed.",
  },
};

export const EmptyState = ({
  title,
  subtitle,
  variant = "search",
}: {
  title?: string;
  subtitle?: string;
  variant?: EmptyStateVariant;
}) => {
  const config = VARIANTS[variant];
  const StateIcon = config.icon;

  return (
    <div className="tw-flex tw-h-[204px] tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-self-stretch tw-px-6 tw-py-10">
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-6">
        <StateIcon size={40} stroke={0.5} className="tw-size-10 tw-shrink-0 tw-text-blue-500" style={{ strokeWidth: 0.5 }} />
        <div className="tw-flex tw-w-[321px] tw-flex-col tw-items-start tw-gap-2">
          <h2 className="tw-m-0 tw-w-full tw-text-center tw-font-sans tw-text-[20px] tw-font-semibold tw-leading-[28px] tw-text-blue">
            {title || config.title}
          </h2>
          <p className="tw-m-0 tw-w-full tw-text-center tw-font-sans tw-text-[16px] tw-font-normal tw-leading-[24px] tw-text-blue-500">
            {subtitle || config.subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};
